<div class="toggle-container" role="switch"
    [class.disabled]="disabled"
    [class.checked]="value" 
    [attr.aria-checked]="value"
    (click)="toggle()"
>
  <div class="toggle-handle"></div>
</div>
